import 'react-app-polyfill/ie11';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
import 'core-js/features/string/ends-with';
import 'core-js/features/array/includes';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/keys';
import 'core-js/features/object/values';
import 'core-js/es/set';
import 'core-js/features/number/is-finite'; // recharts
import 'core-js/features/number/is-nan';



// WEBPACK FOOTER //
// ./src/polyfills.ts